import React from 'react'
import SelectMultipleField from '../input/SelectMultipleField'
import useFetchData from '../../../hooks/useFetchData'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'

export const SelectMultipleFieldYears = ({ id, onChange, name, value = [], keyValue = '_id', error, disabled, isPreview }) => {
  const { isLoading, data, error: errorFetch } = useFetchData('setting/year')

  if (isPreview) {
    return (
      <Typography variant='inherit' component='p'>
        { isLoading && <Skeleton variant='text' width={100} /> }
        { !isLoading && data?.filter(item => value.includes(item?.[keyValue])).map((item) => item.name).join(', ') }
      </Typography>
    )
  }

  return (
    <SelectMultipleField
      id={id}
      error={errorFetch || error}
      helperText={errorFetch || error}                    
      value={value}
      name={name}
      onChange={onChange}      
      options={data?.map(item => ({ value: item?.[keyValue], label: item.name })) || []}
      placeholder="Choose a year level"
      loading={isLoading}
      disabled={isLoading || disabled}
    />  
  )
}
